import React from 'react';

import PropTypes from 'prop-types';
import { Box, Divider, Notification, StackView, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import AddDetailsForm from './components/addDetailsForm';
import InfoList from './components/infoList';
import SectionHeading from '../sectionHeading';

const TankDetails = ({ tankDetails, setTankDetails, error }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    iotOrderDetailsSection: { tankDetailsHeading }
  } = localizedStrings;

  const containerStyles = {
    border: '1px solid',
    borderColor: error ? '#c12335' : '#e3e3e3',
    padding: '1.5rem'
  };

  return (
    <div style={containerStyles}>
      <StackView space={3}>
        <SectionHeading><Typography heading="h4" variant={{ size: 'h4' }} block>{tankDetailsHeading}</Typography></SectionHeading>
        <AddDetailsForm
          tankDetails={tankDetails}
          setTankDetails={setTankDetails}
          sectionError={error}
        />
        {tankDetails.length > 0 && (
          <InfoList tankDetails={tankDetails} setTankDetails={setTankDetails} />
        )}
      </StackView>
      {error && (
        <Notification variant={{ validation: 'error' }}>
          {error}
        </Notification>
      )}
      <Divider space={3} variant={{ inverse: true }} />
    </div>
  );
};

TankDetails.propTypes = {
  tankDetails: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setTankDetails: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired
};

export default TankDetails;
